
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Dittes from "./Dittes";
import Kegeln from "./Kegeln";
import Impressum from "./Impressum";
import Bergwandern from "./Bergwandern"; // Großbuchstabe! React-Komponenten beginnen immer mit einem Großbuchstaben
import "./App.css";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dittes" element={<Dittes />} />
        <Route path="/kegeln" element={<Kegeln />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/bergwandern" element={<Bergwandern />} />
      </Routes>
    </Router>
  );
}

export default App;
